<template>
    <div class="Page">
        <Header Act="2"></Header>
        <div class="MaxWid">
            <!-- <div class="MarTop">
                <Banner></Banner>
            </div> -->
            <div class="MarTop">
                <div class="AboutPos">当前位置：关于我们</div>
                <div class="AboutDis por">
                    <div class="AboutNav">
                        <div class="AboutNavItem" v-for="item in Data" :class="{Act:i==item.id}" @click="TogglePage(item.id)"><i class="iconfont" :class="{[item.icon]:true}"></i>{{item.name}}</div>
                        <!-- <div class="AboutNavItem" :class="{Act:i==1}" @click="TogglePage(1)"><i class="iconfont icon-jianjie"></i>系统简介</div>
                        <div class="AboutNavItem" :class="{Act:i==2}" @click="TogglePage(2)"><i class="iconfont icon-zuzhi"></i>组织机构</div>
                        <div class="AboutNavItem" :class="{Act:i==3}" @click="TogglePage(3)"><i class="iconfont icon-caidan"></i>管理办法</div>
                        <div class="AboutNavItem" :class="{Act:i==4}" @click="TogglePage(4)"><i class="iconfont icon-xiaoxi"></i>联系我们</div> -->
                    </div>
                    <div v-if="i == 4" class="por">
                        <div class="NoDataBtn NoDataBtn1 poa" @click="GoMySuggestion">联系我们</div>
                        <div class="ContactInfo poa">电话：010-64001718（工作日9:00-11:30；14:00-16:30）</div>
                    </div>
                    <div v-else>
                        <div class="AboutCont" v-if="Cont" v-html="Cont.content"></div>
                        <div class="AboutCont" v-else>暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <el-dialog :visible.sync="suggestBlon" :width="Wid" :show-close="false" @close="suggestBlon=false">
            <div class="StepJiBen">
                <!-- <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">反馈类型</span></div>
                    <div class="StepJiBenItemVal">
                        <el-select class="WidMax" size="medium" placeholder="请选择" v-model="SetData.group">
                            <el-option label="项目" value="项目"></el-option>
                            <el-option label="专业人员注册" value="专业人员注册"></el-option>
                            <el-option label="专业机构注册" value="专业机构注册"></el-option>
                            <el-option label="伦理投诉" value="伦理投诉"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="StepJiBenItem">
                    <div class="StepJiBenItemTit"><span class="Tit">反馈内容</span></div>
                    <div class="StepJiBenItemVal">
                        <el-input type="textarea" :rows="6" placeholder="请输入" v-model="SetData.content"></el-input>
                    </div>
                </div>
            </div>
            <div class="OrderBtns">
                <div class="OrderBtn" @click="suggestBlon=false">取消</div>
                <div class="OrderBtn BgBlue" @click="SetInfo">提交</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    export default {
        components: {Header,Footer,Banner},
        data() {
            return {
                i:1,
                Data: "",
                Cont:"",
                Wid:"60%",
                suggestBlon: false,
                SetData:{
                    group:"",
                    content:"",
                },
            }
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData() {
                this.$get("api/index/contentCategory").then(res => {
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                        // 检查URL参数中是否有id
                        const routeId = this.$route.query.id;
                        if (routeId) {
                            this.i = parseInt(routeId);
                            this.GetCont(this.i);
                        } else {
                            this.GetCont(this.Data[0].id);
                        }
                    }
                })
            },
            GetCont(id){
                this.Cont = "";
                this.$post("api/index/content",{
                   category_id:id,
                }).then(res => {
                    if(res.data.code == 1){
                        this.i = id;
                        this.Cont = res.data.data;
                    }
               })
            },
            TogglePage(i){
                this.i = i;
                this.GetCont(i)
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            GoMySuggestion() {
                this.suggestBlon = !this.suggestBlon;
            },
            SetInfo(){
                // if(this.SetData.group == ""){this.$message.error("请选择反馈类型");return;}
                if(this.SetData.content ==""){this.$message.error("请输入反馈内容");return;}
                var Quy = JSON.parse(JSON.stringify(this.SetData))
                this.$post("api/user/messageAdd",Quy).then(res => {
                     if(res.data.code == 1){
                         this.page = 1;
                         this.SetData = {};
                         this.GoMySuggestion();
                         this.$message.success(res.data.msg)
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }

    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutDis{
        display: flex;
        margin-bottom: 30px;
    }
    .AboutNav{
        width: 250px;
        background: #0385EB;
    }
    .AboutNavItem{
        padding: 15px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .AboutNavItem:hover,
    .AboutNavItem.Act{
        background: #fff;
        color: #0385EB;
    }
    .AboutNavItem .iconfont{
        font-size: 22px;
        margin-right: 10px;
    }
    .AboutCont{
        max-width: 900px;
        overflow: auto;
        flex: 1;
        margin-left: 20px;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 36px;
    }
    .NoDataBtn {
        cursor: pointer;
        width: 90px;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        padding: 7px 15px;
        border-radius: 20px;
        background: #0385EB;
        margin: 0 auto;
    }
    .NoDataBtn1 {
        margin: 0;
        margin-bottom: 10px;
        text-align: center;
        font-size: 16px;
    }
    .por {
        position: relative;
        flex: 1;
        min-height: 100px;
    }
    .poa {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .ContactInfo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        color: #666666;
        text-align: center;
        margin-top: 20px;
    }
    .StepJiBen{
       width: 100%;
   }
   .StepJiBenItem{
       display: flex;
       align-items: center;
       margin-bottom: 40px;
   }
   .StepJiBenItemTit{
       width: 135px;
       text-align: right;
       margin-right: 20px;
   }
   .StepJiBenItemTit .Tit{
       font-weight: 400;
       font-size: 16px;
       color: #999;
   }
   .StepJiBenItemVal{
       flex: 1;
   }
   .StepJiBenItemVal .WidMax{
       width: 100%;
   }
   .OrderBtns{
       display: flex;
       align-items: center;
       justify-content: center;
       margin: 20px 0;
   }
   .OrderBtn{
        padding: 5px 40px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        color: #0385EB;
        border-radius: 30px;
        border: 1px solid #0385EB;
        margin-right: 20px;
        cursor: pointer;
   }
   .OrderBtn.BgBlue{
       background: #0385EB;
       color: #fff;
   }
    @media only screen and (max-width: 550px){
        .AboutDis{
            display: block;
            margin-bottom: 30px;
        }
        .AboutNav{
            width: 100%;
            display: flex;
            margin-bottom: 20px;
        }
        .AboutNavItem{
            padding: 15px 0;
            font-size: 16px;
            text-align: center;
            flex: 1;
        }
        .AboutNavItem .iconfont{
            display: none;
        }
        .AboutCont{
            margin: 0;
        }
    }
</style>